module.exports = __webpack_public_path__ + "img/kayak003.a5571b39.jpg";